import React from 'react';

export const Instruction = ({ title, text }) => (
    <li className="instruction-item">
        <p className="instruction-title">{title}</p>
        <p className="instruction-text">{text}</p>
    </li>
);
